import type { LeagueScope, PermissionScopeResources } from "~types/permissionScope.ts";
import type { SeasonTransformed } from "~types/seasonTransformed.ts";

const extractSeasonsFromScopeByCompetitionId = (
  leagueTree: LeagueScope[],
  resources: PermissionScopeResources,
  competitionId?: string,
): SeasonTransformed[] => {
  if (!competitionId) return [];
  const seasonsData = resources.seasons || {};
  const competitionsData = resources.competitions || {};
  const seasons: SeasonTransformed[] = [];

  leagueTree?.forEach(({ competitions }) => {
    const competition = competitions.find((comp) => comp.competitionId === competitionId);
    if (competition) {
      const competitionName = competitionsData[competitionId]?.nameLocal || "";
      seasons.push(...competition.seasonIds.map((seasonId) => ({ ...seasonsData[seasonId], competitionName })));
    }
  });

  return seasons;
};

export default extractSeasonsFromScopeByCompetitionId;
